export function formatBRDate(value) {
  if (!value) return "";

  const normalized = String(value).trim();

  const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    const [, year, month, day] = match;
    return `${day}/${month}/${year}`;
  }

  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return "";

  try {
    return new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  } catch {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }
}

export function getDoseDate(dose) {
  const raw =
    dose?.dateTime ||
    dose?.datetime ||
    dose?.scheduledAt ||
    dose?.scheduledFor ||
    dose?.date ||
    dose?.when ||
    dose?.createdAt;

  const date = raw ? new Date(raw) : null;

  if (!date || Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
}

export function isCompletedDose(dose) {
  const status = String(dose?.status || "").toLowerCase();

  return (
    status === "aplicada" ||
    status === "aplicado" ||
    status === "concluida" ||
    status === "concluído" ||
    status === "concluido" ||
    status === "done" ||
    status === "completed"
  );
}

export function todayISO() {
  const date = new Date();
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}`;
}

export function isoAtNoonUTC(dateOnly) {
  if (!dateOnly || !/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) {
    return null;
  }

  return `${dateOnly}T12:00:00.000Z`;
}

export function sameLocalDay(a, b) {
  if (!(a instanceof Date) || !(b instanceof Date)) {
    return false;
  }

  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function formatTimeHHMM(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return "";
  }

  try {
    return new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  } catch {
    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    return `${hh}:${mm}`;
  }
}